
'use strict';
import {Injectable, Inject} from 'ng-metadata/core';
import {getVid, getInstitutionCode} from '../../../../../appConfig/appConfigForward';
import {ConfigurationUtil} from '../../../../../nddUtils/configurationUtil.service';
import {LocationService} from '../locations/location/location.service';
const uniqBy= require('lodash/uniqBy');
const uniq= require('lodash/uniq');
const _get = require('lodash/get');


@Injectable()
export class LocationsFilterService {
    private vid: string= getVid();
    private filterConfig: string;
    private _dropDownOptions: {
        locations: string[];
        years: string[];
        volumes: string[];
        descriptions: string[];
    };
    private _filters: Object = {};

    constructor(@Inject('$http') private $http:ng.IHttpService,
                @Inject('restBaseURLs') private restBaseURLs: Object,
                private locationService: LocationService,
                private configurationUtil: ConfigurationUtil) {
        this.filterConfig= this.getFilterConfig();
    }



    get dropDownOptions(){
        return this._dropDownOptions;
    }


    private _locationFilter: string;
    private _yearFilter: string;
    private _volumeFilter: string;
    private _descriptionFilter: string;

    get selectedFilter() {
        return this._filters;
    }

    set selectedFilter(selectedFilter) {
        this._filters = selectedFilter;
    }

    public setFilterDropDownOptions(item, dropDownOptions){
        if (!dropDownOptions) {
            return;
        }

        if (this.filterConfig==='all_filters'){
            this.getYearAndVolumeDropDownOptions(item, dropDownOptions);
        }

        dropDownOptions.locations = this.getLocationDropDownOptions(item);

    }

    private getFilterConfig() {
        if (this.configurationUtil.getLocationsConfiguration())
            return this.configurationUtil.getLocationsConfiguration().filtersop;
    }

    public getLocationDropDownOptions(item){

        let locationsObj = item.delivery.holding || [];
        let onlyViewInst = this.configurationUtil.getLocationsConfiguration().viewinstsort;
        if (onlyViewInst) {
            locationsObj = locationsObj.filter((loc)=>{return (!onlyViewInst || loc.organization === getInstitutionCode());});
        }
        let locations = locationsObj.map((location)=> location.libraryCode+":"+this.locationService.getLibraryName(location));

        return uniq(locations);
    }

    private getYearAndVolumeDropDownOptions(item, dropDownOptions){
        let params= item.delivery.holding || [];
        params= params.map((location)=>{return {ilsApiId: location.ilsApiId, institution: location.organization}});
        params= uniqBy(params, (val)=>val.ilsApiId);
        params= params.reduce((prev, cur)=>{prev['ils-record-id']+=cur.ilsApiId + ',';
                                                prev['record-institution']+= cur.institution+ ',';
                                                return prev;},
                                    {'ils-record-id':'', 'record-institution':''});
        params['ils-record-id']= params['ils-record-id'].slice(0,-1);
        params['record-institution']= params['record-institution'].slice(0,-1);
        this.$http.get(this.restBaseURLs.ILSServicesBaseURL+'/filters',{params: params}).then((response)=>{this.parseFiltersApiResponse(response, dropDownOptions)});
    }

    private parseFiltersApiResponse(response, dropDownOptions){
        let data= response.data.data;
        data= data.map((val)=>{return this.parseLocationFilters(val)});
        data= data.reduce((prev,cur)=>{return {years: prev.years.concat(cur.years), volumes: prev.volumes.concat(cur.volumes), descriptions: prev.descriptions.concat(cur.descriptions)}}, {years:[], volumes:[], descriptions:[]});
        if (dropDownOptions) {
            dropDownOptions.years= uniq(data.years);
            dropDownOptions.volumes= uniq(data.volumes);
            dropDownOptions.descriptions= uniq(data.descriptions);
        }
    }

    private parseLocationFilters(val){
        if (!val){
            return {years: [], volumes: [], descriptions: []};
        }
        return {years: _get(val,'filters.years.year'), volumes: _get(val,'filters.volumes.volume'), descriptions: _get(val,'filters.descriptions.description')};
    }

    deleteFilterOptions(){
        this._dropDownOptions= undefined;
        this.locationFilter= undefined;
        this.yearFilter =undefined;
        this.volumeFilter= undefined;
        this.descriptionFilter= undefined;
    }

     get isFilterClicked(){
        if((this.locationFilter && this.locationFilter !== 'All') ||
            (this.volumeFilter && this.volumeFilter !== 'All') ||
            (this.yearFilter && this.yearFilter !== 'All') ||
            (this.descriptionFilter && this.descriptionFilter !== 'All')){
            return true;
        }
        return false;
    }
}
//put here all angular1 modules the service is using
export default [];



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/locationsFilter/locationsFilter.service.ts